import styled from 'styled-components';
import { colors } from 'View/Theme';
import { asRem } from 'utils/asRem';

export default styled.hr`
  border: solid ${asRem(1)} ${colors.sleep.blue.c300};
  margin-bottom: ${asRem(16)};
  margin-top: 0;
`;
